export default __webpack_public_path__ + "static/media/dog.85eecf8b.svg";